export default "__VITE_ASSET__4b6fd7bb__"